document.addEventListener("DOMContentLoaded", () => {
  //localStorage.removeItem('viewedProducts');
  let viewedFromStorage = JSON.parse(localStorage.getItem('viewedProducts')) || [];

  // console.log('viewedFromStorage', viewedFromStorage);


  // using mainProduct object
  let product_name;
  if (mainProduct.type === 'Sunglasses') {
    product_name = mainProduct.title
  } else {
    product_name = `${mainProduct.brand} ${mainProduct.frame}`
  }
  let currentProduct = {
    brand: mainProduct.brand,
    name: product_name,
    url: window.location.pathname,
    image: mainProduct.featured_image,
    handle: mainProduct.handle,
    collections: mainProduct.collection_handles
  }

  const addItem = () => {
    viewedFromStorage.unshift(currentProduct); // let's add it as the first item
    // var saveProductsLimit is from a setting in sections/main-product.liquid
    if (viewedFromStorage.length > saveProductsLimit) viewedFromStorage.pop();
    localStorage.setItem('viewedProducts', JSON.stringify(viewedFromStorage))
  }
  if (viewedFromStorage.length > 0) {
    const checkProductName = (item) => item.name === currentProduct.name;
    const viewedProductIndex = viewedFromStorage.findIndex(checkProductName)
    // console.log('viewedProductIndex:', viewedProductIndex)
    if (viewedProductIndex === -1) {
      addItem();
    };
  } else {
    addItem();
  }
  
  
  // console.log('currentProduct', currentProduct);
  // console.log('viewedFromStorage', viewedFromStorage);
});